import { render, staticRenderFns } from "./WellHung.vue?vue&type=template&id=6bb79ef0&scoped=true&"
import script from "./WellHung.vue?vue&type=script&lang=js&"
export * from "./WellHung.vue?vue&type=script&lang=js&"
import style0 from "./WellHung.vue?vue&type=style&index=0&id=6bb79ef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb79ef0",
  null
  
)

export default component.exports